import { React, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Row, Col, BreadcrumbItem, Button } from "reactstrap";
import github from "../../assets/images/brands/github.png";
import FeatherIcon from "feather-icons-react";

const Breadcrumb = (props) => {
  const [maxIcon, setMaxIcon] = useState("maximize");

  const expandClick = () => {
    var _page = document.getElementsByClassName("page-content");
    console.log(_page.length);
    if (_page.length > 0) {
      _page[0].className = "fullScreenView";
      setMaxIcon("minimize");
    } else {
      var _page = document.getElementsByClassName("fullScreenView");
      _page[0].className = "page-content";
      setMaxIcon("maximize");
    }
  };

  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between piers-page-header">
          <h4 className="mb-0 font-size-18 piers-page-title">{props.breadcrumbItem}</h4>
          <div className="page-title-right">
            {props.enableAction ? (
              <Button
                type="button"
                className="btn btn-success waves-effect waves-light me-2"
                tag={Link}
                to="#"
                onClick={props.onClick}
                color="success"
              >
                <i className="bx bx-plus font-size-16 align-middle me-2"></i>{" "}
                {props.actionName}
              </Button>
            ) : (
              ""
            )}

            {props.enableRefresh ? (
              <Button
                type="button"
                className="btn btn-success waves-effect waves-light me-2 piers-refresh-button"
                tag={Link}
                to="#"
                onClick={props.onClick}
                color="success"
              >
                <i className="bx bx-refresh font-size-16 align-middle me-2"></i>{" "}
                Refresh
              </Button>
            ) : (
              ""
            )}

            {/*<div style={{ paddingLeft: '25px', paddingRight: '10px', display: 'inline' }}>*/}
            {/*    <a style={{ cursor: 'pointer' }} onClick={expandClick}>*/}
            {/*        <FeatherIcon icon={maxIcon} />*/}
            {/*    </a>*/}
            {/*</div>*/}
          </div>
        </div>
      </Col>
    </Row>
  );
};

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
  enableAction: PropTypes.bool,
  actionName: PropTypes.string,
};

export default Breadcrumb;
